import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {SubscriptionItem} from '../types';
import {FormWithButtons} from "@flexinet/ui-components";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<SubscriptionItem, 'id'>,
    // Returns the mutation promise so Formik can keep isSubmitting true until
    // it settles (§6). `void` is still accepted for callers that do not await.
    handleSubmit: (values: SubscriptionItem) => void | Promise<unknown>,
    handleCancel?: () => void
}) => {


    /**
     * FNP-918: `onSubmit` is async and RETURNS the mutation promise (§6).
     *
     * ⚠️ It previously called `handleSubmit(values)` and dropped the promise.
     * Formik then cleared `isSubmitting` on the same tick, so the shared
     * button's "disabled while submitting" never engaged and a double-click
     * fired the mutation twice. The disabled wiring was present and correct the
     * whole time — it simply never fired, which is why this survives review.
     */
    const onSubmit = async (values: SubscriptionItem) => {
        return handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {
        subscription: '',
        price: '',
    } as SubscriptionItem;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }


    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting} handleCancel={onCancel}
                                 debug={false} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>
            )}


        </Formik>
    );
};
